<div class="cyber-status-container">
  <!-- Spectacular Header -->
  <div class="cyber-status-header-spectacular">
    <div class="cyber-header-content">
      <div class="cyber-header-main">
        <div class="cyber-header-icon">
          <i class="bi bi-plugin"></i>
        </div>
        <div class="cyber-header-text">
          <h2 class="cyber-header-title">Scanner Connectors</h2>
        </div>
      </div>
      <div class="cyber-header-actions">
        <button class="btn-cyber-primary" (click)="addConnector()">
          <i class="bi bi-plus-circle"></i> Add Connector
        </button>
        <button class="btn-cyber-secondary" (click)="goToDashboard()">
          <i class="bi bi-house"></i> Dashboard
        </button>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div class="cyber-loading-state" aria-live="polite">
      <div class="cyber-spinner">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <p class="cyber-loading-text">Loading connectors...</p>
    </div>
  }

  <!-- Error State -->
  @if (error && !loading) {
    <div class="cyber-alert cyber-alert-danger">
      <i class="bi bi-exclamation-triangle"></i>
      {{ error }}
    </div>
  }

  <!-- Empty State -->
  @if (!loading && !error && connectorIds.length === 0) {
    <div class="cyber-empty-state">
      <div class="cyber-empty-icon">
        <i class="bi bi-plugin"></i>
      </div>
      <h5 class="cyber-empty-title">No Connectors Configured</h5>
      <p class="cyber-empty-subtitle">
        Get started by adding your first scanner connector.
      </p>
      <button class="btn-cyber-primary" (click)="addConnector()">
        <i class="bi bi-plus-circle"></i> Add Your First Connector
      </button>
    </div>
  }

  <!-- Connector List -->
  @if (!loading && !error && connectorIds.length > 0) {
    <div class="connector-list">
      @for (id of connectorIds; track id) {
        <div class="cyber-connector-card">
          <div class="cyber-connector-header">
            <div class="cyber-connector-icon">
              <span class="vendor-icon">{{ getVendorIcon(getConnectorConfig(id)?.vendor || '') }}</span>
            </div>
            <div class="cyber-connector-info">
              <h5 class="cyber-connector-name">
                {{ getConnectorConfig(id)?.metadata?.displayName || id }}
              </h5>
              <span class="cyber-status-badge cyber-status-active">
                <i class="bi bi-check-circle"></i> Active
              </span>
            </div>
            <div class="cyber-connector-actions">
              <button class="btn-cyber-danger-sm" (click)="deleteConnector(id)" title="Delete connector">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
          <div class="cyber-connector-body">
            <div class="cyber-detail-grid">
              <div class="cyber-detail-item">
                <span class="cyber-detail-label">
                  <i class="bi bi-building"></i> Vendor
                </span>
                <span class="cyber-detail-value">{{ $safeNavigationMigration(getConnectorConfig(id)?.vendor) | titlecase }}</span>
              </div>
              @if (getConnectorConfig(id)?.metadata?.baseUrl) {
                <div class="cyber-detail-item">
                  <span class="cyber-detail-label">
                    <i class="bi bi-link"></i> Base URL
                  </span>
                  <span class="cyber-detail-value">{{ getConnectorConfig(id)?.metadata?.baseUrl }}</span>
                </div>
              }
              @if (getConnectorConfig(id)?.createdAt) {
                <div class="cyber-detail-item">
                  <span class="cyber-detail-label">
                    <i class="bi bi-calendar-plus"></i> Configured
                  </span>
                  <span class="cyber-detail-value">{{ $safeNavigationMigration(getConnectorConfig(id)?.createdAt) | date:'medium' }}</span>
                </div>
              }
              @if (getConnectorConfig(id)?.lastValidatedAt) {
                <div class="cyber-detail-item">
                  <span class="cyber-detail-label">
                    <i class="bi bi-check2-circle"></i> Last Validated
                  </span>
                  <span class="cyber-detail-value">{{ $safeNavigationMigration(getConnectorConfig(id)?.lastValidatedAt) | date:'medium' }}</span>
                </div>
              }
              @if (getConnectorConfig(id)?.metadata?.notes) {
                <div class="cyber-detail-item cyber-detail-full">
                  <span class="cyber-detail-label">
                    <i class="bi bi-journal-text"></i> Notes
                  </span>
                  <span class="cyber-detail-value">{{ getConnectorConfig(id)?.metadata?.notes }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Info Card -->
  @if (!loading && connectorIds.length > 0) {
    <div class="cyber-card cyber-info-card mt-4">
      <div class="cyber-info-header">
        <i class="bi bi-info-circle"></i>
        <h6 class="cyber-info-title">Local Mode Active</h6>
      </div>
      <p class="cyber-info-text">
        Your scanner credentials are encrypted and stored locally in your browser.
        Make sure to remember your passphrase - it cannot be recovered if lost.
      </p>
    </div>
  }
</div>
